import { render, staticRenderFns } from "./SaveChangesDialog.vue?vue&type=template&id=4da6e3df&scoped=true"
import script from "./SaveChangesDialog.vue?vue&type=script&lang=js"
export * from "./SaveChangesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6e3df",
  null
  
)

export default component.exports